import { MEDIA_URL } from '@/constants/env';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';

export default function TestimonialBox({
  image,
  name,
  jobFunction,
  employedSince,
  message,
  ...props
}) {
  const imageUrl = image?.data?.attributes?.url ? MEDIA_URL.concat(image.data.attributes.url) : '';
  return (
    <motion.div
      className="relative mt-16 flex flex-col items-center rounded-xl bg-white p-8 shadow-lg ring-1 ring-neutral-100"
      {...props}
    >
      <div className="absolute top-4 left-4 z-10 text-5xl text-primary-500">&#10077;</div>
      {imageUrl ? (
        <Image
          alt="Person"
          className="-mt-24 h-48 w-48 overflow-hidden rounded-full object-cover"
          src={imageUrl}
        />
      ) : null}
      <div className="mt-4 text-center">
        <h2 className="text-3xl font-semibold">{name}</h2>
        <h3 className="text-lg text-primary-500">{jobFunction}</h3>
        <h4 className="font-light text-neutral-600">Employed since {employedSince}</h4>
        <p className="mt-4 text-lg font-light italic">{message}</p>
      </div>
    </motion.div>
  );
}
